export default {
  pt: {
    title: "Conheça os termos antes de prosseguir",
    rejectButton: "Recusar",
    acceptButton: "Aceitar",
  },
  en: {
    title: "Read the terms before proceeding",
    rejectButton: "Reject",
    acceptButton: "Accept",
  },
}; 